var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineexperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6761 30.6667H12.8067C8.02675 30.6667 5.63741 30.6667 4.15208 29.1533C2.66675 27.64 2.66675 25.204 2.66675 20.3333C2.66675 15.4627 2.66675 13.0267 4.15208 11.5133C5.63741 10 8.02675 10 12.8067 10H17.8774C22.6574 10 25.0481 10 26.5334 11.5133C27.6761 12.6773 27.9387 14.388 28.0001 17.3333V19.3333",
    stroke: "#E4002B",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 26.6667H21.3335M21.3335 30.6667C20.2726 30.6667 19.2552 30.2453 18.5051 29.4951C17.7549 28.745 17.3335 27.7275 17.3335 26.6667C17.3335 25.6058 17.7549 24.5884 18.5051 23.8382C19.2552 23.0881 20.2726 22.6667 21.3335 22.6667M25.3335 30.6667C26.3944 30.6667 27.4118 30.2453 28.1619 29.4951C28.9121 28.745 29.3335 27.7275 29.3335 26.6667C29.3335 25.6058 28.9121 24.5884 28.1619 23.8382C27.4118 23.0881 26.3944 22.6667 25.3335 22.6667M21.3335 10L21.2002 9.58668C20.5402 7.53334 20.2108 6.50668 19.4255 5.92001C18.6388 5.33334 17.5962 5.33334 15.5082 5.33334H15.1575C13.0708 5.33334 12.0268 5.33334 11.2415 5.92001C10.4548 6.50668 10.1255 7.53334 9.4655 9.58668L9.3335 10",
    stroke: "#E4002B",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineexperience);
export default __webpack_public_path__ + "static/media/offlineexperience.1d302a49b5230380e7fef6b967c68ec8.svg";
export { ForwardRef as ReactComponent };